import { zodResolver } from '@hookform/resolvers/zod';
import type { FieldValues, Resolver } from 'react-hook-form';
import type { z } from 'zod';

/**
 * Typed wrapper around zodResolver that properly infers form types from Zod 4 schemas.
 * Contains the single acceptable cast for the @hookform/resolvers generic gap (D-03).
 */
export function typedResolver<T extends z.ZodType>(
  schema: T
): Resolver<z.output<T> & FieldValues> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- @hookform/resolvers zod4 generic inference gap (D-03)
  return zodResolver(schema as any) as Resolver<z.output<T> & FieldValues>;
}
